<template>
  <div
    class="containui"
    v-if="list"
    v-loading="loading"
    element-loading-text="拼命加载中"
  >
    <div class="contain-top">
      <span class="span"
        >总分:<span class="score">{{
          list.is_score == 1 ? list.score : "暂未评分"
        }}</span></span
      >
    </div>
    <div
      class="big-list"
      v-for="(item, index) in list.answer_snap ? list.answer_snap.snap : []"
      :key="index"
    >
      <div
        class="big"
        v-if="
          item.student_question_bank ? item.student_question_bank.type == 1 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.单选题<span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="contain-center-check">
            <div class="contain-center-check-left">
              <div
                class="contain-center-check-box"
                v-for="(items, indexs) in item.student_question_bank.option"
                :key="indexs"
              >
                <img
                  v-if="item.student_answer_content == items.name + indexs"
                  src="../../../../assets/image/checked.png"
                  alt=""
                />
                <img
                  v-else
                  src="../../../../assets/image/no_checked.png"
                  alt=""
                />
                <span>{{ items.content }}</span>
              </div>
            </div>
            <img
              class="img"
              v-if="
                item.student_answer_content == item.student_question_bank.answer
              "
              src="../../../../assets/image/success.png"
              alt=""
            />
            <img
              class="img"
              v-else
              src="../../../../assets/image/error.png"
              alt=""
            />
          </div>
        </div>
        <div class="contain-bottom">
          <div class="contain-bottom-score">
            得分：<span class="num">{{ item.answer_score }}</span>
          </div>
          <div class="contain-bottom-top">答案解析</div>
          <div class="contain-bottom-success">
            正确答案：<span>{{
              String.fromCharCode(item.student_question_bank.answer)
            }}</span>
          </div>
          <div class="contain-bottom-msg">
            {{
              item.student_question_bank.analysis
                ? item.student_question_bank.analysis
                : ""
            }}
          </div>
        </div>
      </div>
      <div
        class="big"
        v-if="
          item.student_question_bank ? item.student_question_bank.type == 2 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.多选题<span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="contain-center-check">
            <div class="contain-center-check-left">
              <div
                class="contain-center-check-box"
                v-for="(items, indexs) in item.student_question_bank.option"
                :key="indexs"
              >
                <img
                  v-if="items.isanswer"
                  src="../../../../assets/image/checked.png"
                  alt=""
                />
                <img
                  v-else
                  src="../../../../assets/image/no_checked.png"
                  alt=""
                />
                <span>{{ items.content }}</span>
              </div>
            </div>
            <img
              class="img"
              v-if="
                item.student_answer_content == item.student_question_bank.answer
              "
              src="../../../../assets/image/success.png"
              alt=""
            />
            <img
              class="img"
              v-else
              src="../../../../assets/image/error.png"
              alt=""
            />
          </div>
        </div>
        <div class="contain-bottom">
          <div class="contain-bottom-score">
            得分：<span class="num">{{ item.answer_score }}</span>
          </div>
          <div class="contain-bottom-top">答案解析</div>
          <div class="contain-bottom-success">
            正确答案：<span
              v-for="i in item.student_question_bank.answer.split(',')"
              :key="i"
            >
              {{ String.fromCharCode(i) }}
            </span>
          </div>
          <div class="contain-bottom-msg">
            {{
              item.student_question_bank.analysis
                ? item.student_question_bank.analysis
                : ""
            }}
          </div>
        </div>
      </div>
      <div
        class="big"
        v-else-if="
          item.student_question_bank ? item.student_question_bank.type == 3 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.填空题 <span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="contain-center-content">
            <div class="contain-center-content-box">
              <span>我的答案：</span>
              <span v-for="(gop, i) in item.student_answer_content" :key="i">
                {{ gop }}
              </span>
              <!-- {{ item.student_answer_content }} -->
            </div>
          </div>
        </div>
        <div class="contain-bottom" v-if="item.is_score == 1">
          <div class="contain-bottom-score">
            得分：<span class="num">{{ item.answer_score }}</span>
          </div>
          <div class="contain-bottom-top">答案解析</div>
          <div class="contain-bottom-success">
            正确答案：<span style="color: red">{{
              item.student_question_bank.answer
            }}</span>
          </div>
          <div class="contain-bottom-msg">
            {{
              item.student_question_bank.analysis
                ? item.student_question_bank.analysis
                : ""
            }}
          </div>
        </div>
      </div>
      <div
        class="big"
        v-else-if="
          item.student_question_bank ? item.student_question_bank.type == 5 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.判断题<span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="contain-center-check">
            <div
              class="contain-center-check-left"
              style="display: flex; margin-top: 30px"
            >
              <div
                class="contain-center-checkbox"
                :class="
                  item.student_answer_content == '正确'
                    ? 'contain-center-checkbox-check'
                    : ''
                "
                style="margin-right: 20px"
              >
                <i class="el-icon-success" style="margin-right: 10px"></i> 正确
              </div>
              <div
                class="contain-center-checkbox"
                :class="
                  item.student_answer_content == '错误'
                    ? 'contain-center-checkbox-check'
                    : ''
                "
              >
                <i class="el-icon-error" style="margin-right: 10px"></i> 错误
              </div>
            </div>
          </div>
          <div class="textarea">
            <div class="contain-center-content-box">
              <span>我的答案：</span>{{ item.student_answer_content }}
            </div>
            <div class="img-box">
              <img
                class="img"
                v-if="
                  item.student_answer_content ==
                  item.student_question_bank.answer
                "
                src="../../../../assets/image/success.png"
                alt=""
              />
              <img
                class="img"
                v-else
                src="../../../../assets/image/error.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="contain-bottom" v-if="item.is_score == 1">
          <div class="contain-bottom-score">
            得分：<span class="num">{{ item.answer_score }}</span>
          </div>
          <div class="contain-bottom-top">答案解析</div>
          <div class="contain-bottom-success">
            正确答案:<span style="color: red">{{
              item.student_question_bank.answer
            }}</span>
          </div>
          <div class="contain-bottom-msg">
            {{
              item.student_question_bank.answer
                ? item.student_question_bank.analysis
                : ""
            }}
          </div>
        </div>
      </div>
      <div
        class="big"
        v-else-if="
          item.student_question_bank ? item.student_question_bank.type == 4 : ''
        "
      >
        <div class="contain-center">
          <div class="contain-center-top">
            {{ index + 1 }}.简答题<span>（{{ item.score }}分）</span>
          </div>
          <div
            class="contain-center-title"
            v-html="item.student_question_bank.title"
          ></div>
          <div class="textarea">
            <div class="contain-center-content-box">
              <span>我的答案：</span>{{ item.student_answer_content }}
            </div>
          </div>
        </div>
        <div class="contain-bottom" v-if="item.is_score == 1">
          <div class="contain-bottom-score">
            得分：<span class="num">{{ item.answer_score }}</span>
          </div>
          <div class="contain-bottom-top">答案解析</div>
          <div class="contain-bottom-success">参考答案</div>
          <div class="contain-bottom-msg">
            {{
              item.student_question_bank.answer
                ? item.student_question_bank.analysis
                : ""
            }}
          </div>
        </div>
      </div>
    </div>
    <p v-if="noMore && !noData">已经到底了~</p>
  </div>
</template>
<script>
import request from "@/utils/request";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      show: false,
      active: -1,
      query: {
        teacher_paper_id: "",
        limit: 10,
      },
      list: [],
      total: 0,
      form: {
        log_id: "",
        answers: [],
      },
      minutes: 90,
      seconds: 0,
      value: [],
      //倒计时时间
      count_day: "00",
      count_hour: "00",
      count_min: "",
      count_sec: "",
      timer: null,
      loading: true,
      noData: false,
      noMore: false,
    };
  },
  created() {
    if (Cookies.get("Admin-Token")) {
      this.query.teacher_paper_id = this.$route.query.teacher_paper_id;
      this.getSubjectList();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll); // 监听（绑定）滚轮滚动事件
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        if (!this.noMore) {
          console.log("触底");
          this.query.limit += 10;
          this.getSubjectList();
        }
        //写后台加载数据的函数
        // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
      }
    },
    //倒计时
    countdown(endtime) {
      let that = this;
      that.timer = setInterval(() => {
        var downTime = parseInt(
          new Date(endtime.replace(/-/g, "/")).getTime() - new Date().getTime()
        );
        if (downTime <= 0) {
          that.count_min = "00";
          that.count_sec = "00";
          clearInterval(that.timer);
          // this.$router.go(-1)
          return;
        } else {
          var d = parseInt(downTime / 1000 / 3600 / 24);
          var h = parseInt((downTime / 1000 / 3600) % 24);
          var m = parseInt((downTime / 1000 / 60) % 60);
          var s = parseInt((downTime / 1000) % 60);

          d < 10 ? (d = "0" + d) : d;
          h < 10 ? (h = "0" + h) : h;
          m < 10 ? (m = "0" + m) : m;
          s < 10 ? (s = "0" + s) : s;

          that.count_min = m;
          that.count_sec = s;
        }
      }, 1000);
    },
    // 提交试卷
    save() {
      let obj = JSON.parse(JSON.stringify(this.form));
      obj.answers.forEach((item) => {
        if (item.student_answer_content instanceof Array) {
          item.student_answer_content = item.student_answer_content.toString();
        }
      });
      request({
        url: "/api/userend/paper/commitTest",
        method: "post",
        data: obj,
      }).then((response) => {
        this.$message.success("提交成功");
        // this.$router.go(0);//返回上一层
      });
    },
    check(index) {
      this.active = index;
    },
    back() {
      this.$router.push("/mine/my_study/question_bank");
    },
    getSubjectList() {
      this.loading = true;
      request({
        url: "/api/userend/paper/startTest",
        method: "post",
        params: this.query,
      }).then((response) => {
        this.list = response.data;
        this.loading = false;
        this.form.log_id = response.data.id;
        let endtime = response.data.expire_at;
        // this.countdown(endtime)
        this.total = response.data.answer_snap.question_num;
        let length = response.data.answer_snap.snap.length;
        if (length == 0) {
          this.noData = true;
        }
        if (length < this.query.limit) {
          this.noMore = true;
        }
        this.list.answer_snap.snap.forEach((item, index) => {
          item.student_question_bank.option = JSON.parse(
            item.student_question_bank.option
          );
          if (item.student_question_bank.type == 2) {
            //字符串装换对象
            let option = item.student_question_bank.option;
            item.student_answer_content =
              item.student_answer_content.toString();
            let answerList = item.student_answer_content.split(",");
            option.forEach((op, i) => {
              op.name = op.name + i;
              op.isanswer = false;
              for (let index = 0; index < answerList.length; index++) {
                const element = answerList[index];
                if (element == op.name) {
                  op.isanswer = true;
                }
              }
            });
            //自己选择的选项
            // this.details.student_question_bank.option = option;
          }
          if (item.student_question_bank.type == 3) {
            item.student_question_bank.title =
              item.student_question_bank.title.replaceAll("{input}", "_____");
            this.form.answers.push({
              index: index,
              student_answer_content: [],
            });
          } else {
            this.form.answers.push({
              index: index,
              student_answer_content: "",
            });
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
.containui {
  padding: 30px;
  min-height: calc(100vh - 160px);
  background: #ffffff;
  border-radius: 9px;
  .contain-top {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #f9fafd;
    .span {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #506176;
      .score {
        margin-left: 10px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #f24342;
      }
    }
  }
  p {
    text-align: center;
  }
  .big-list {
    .big {
      padding: 30px 0;
      border-bottom: 1px solid #f9fafd;
      .contain-center {
        .contain-center-top {
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #506176;
          span {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #506176;
            margin-left: 20px;
          }
        }
        .contain-center-title {
          margin-top: 20px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 34px;
        }
        .contain-center-content {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          margin-top: 40px;
          .img-box {
            margin-left: 50px;
            .img {
              width: 120px;
              height: 102px;
              margin-left: 140px;
            }
          }
          .contain-center-content-box {
            margin-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            span {
              margin-right: 10px;
            }
          }
        }
        .textarea {
          margin-top: 36px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .img-box {
            margin-left: 50px;
            .img {
              width: 120px;
              height: 102px;
              margin-left: 140px;
            }
          }
        }
        .contain-center-check {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .radio {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .miniRadio {
              margin-top: 15px;
            }
          }
          .img {
            width: 120px;
            height: 102px;
            margin-left: 140px;
          }
          .contain-center-check-left {
            .contain-center-check-box {
              cursor: pointer;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              padding: 25px 0;
              img {
                width: 20px;
                height: 20px;
                border-radius: 50%;
              }
              span {
                margin-left: 17px;
                font-size: 20px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }
            }
          }
        }
        .contain-center-btn {
          margin-top: 45px;
        }
      }
      .contain-bottom {
        margin-top: 20px;
        .contain-bottom-score {
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #506176;
          .num {
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #f24342;
          }
        }
        .contain-bottom-top {
          margin-top: 20px;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #506176;
        }
        .contain-bottom-success {
          margin-top: 15px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          span {
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #f24342;
          }
        }
        .contain-bottom-msg {
          margin-top: 12px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 31px;
        }
      }
    }
  }
}
.contain-center-check {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .img {
    width: 120px;
    height: 102px;
    margin-left: 140px;
  }
  .contain-center-check-left {
    .contain-center-check-box {
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 16px 0;
      img {
        width: 20px;
        height: 20px;
        border-radius: 50%;
      }
      span {
        margin-left: 17px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
    .contain-center-checkbox {
      width: 105px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #cccccc;
      border-radius: 8px;
      color: #999999;
      font-size: 20px;
      cursor: pointer;
    }
    .contain-center-checkbox-check {
      border-color: red;
      color: red;
    }
  }
}
</style>